// extracted by mini-css-extract-plugin
export default {"coffeeButton":"Coffee_coffeeButton__wSPgG","coffeeIcon":"Coffee_coffeeIcon__6LtWG","text":"Coffee_text__yZd7N"};